import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import MetaData from '../shared/metaData/MetaData';
import NameRow from './nameRow/NameRow';
import RaceDays from './raceDays/RaceDays';
import Nav from '../shared/nav/Nav';
import { areAllFieldsEmpty } from '../utils/object';

const CoursePage = ({ data, children, params }) => {
    const courseInfoTab = Object.assign({}, data.admission, data.directions);

    const tabsToExclude = [
        areAllFieldsEmpty(data.standardTimes) && 'course-records',
        areAllFieldsEmpty(courseInfoTab) && 'course-info',
        !data.courseMap && 'course-map',
    ];

    return (
        <div>
            <section>
                <MetaData
                    type={params.type}
                    page={params.tab ? params.tab : 'stats'}
                    name={data.profile.courseStyleName}
                />
                <NameRow profile={data.profile} />
                <RaceDays
                    data={data.upcomingRaces || []}
                    params={params}
                />
            </section>
            <Nav
                params={params}
                helpUrl={data.helpCenterUrl}
                tabsToExclude={tabsToExclude}
            />
            {cloneElement(children, { data, params })}
        </div>
    );
};

CoursePage.propTypes = {
    data: PropTypes.shape({
        helpCenterUrl: PropTypes.string,
    }).isRequired,
    params: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        tab: PropTypes.string,
    }).isRequired,
    children: PropTypes.node.isRequired,
};

export default CoursePage;



// WEBPACK FOOTER //
// ./src/js/course/CoursePage.jsx